import React from "react";
import { Layout, Menu, Drawer } from "antd";
import { Link } from "react-router-dom";
import { adminMenu, userMenu } from "../Config";

const { Sider } = Layout;

const Sidebar = ({
  collapsed,
  setCollapsed,
  mobileOpen,
  setMobileOpen,
  isMobile,
  role = "admin",
}) => {

  const menuItems = role === "admin" ? adminMenu : userMenu;

  const formatMenu = (items) =>
    items.map((item) =>
      item.children
        ? {
          key: item.key,
          icon: item.icon,
          label: item.label,
          children: formatMenu(item.children),
        }
        : {
          key: item.key,
          icon: item.icon,
          label: <Link to={item.path}>{item.label}</Link>,
        }
    );

  const menuContent = (
    <>
      <div
        style={{
          height: 60,
          margin: "0 15px 20px",
          background: "rgba(255,255,255,0.1)",
          borderRadius: 12,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 700,
          fontSize: 20,
        }}
      >
        Yoga Admin
      </div>

      <Menu
        theme="dark"
        mode="inline"
        items={formatMenu(menuItems)}
        style={{ background: "transparent" }}
        onClick={() => isMobile && setMobileOpen(false)}
      />
    </>
  );

  // ✅ Mobile Drawer
  if (isMobile) {
    return (
      <Drawer
        placement="left"
        closable={false}
        onClose={() => setMobileOpen(false)}
        open={mobileOpen}
        bodyStyle={{
          padding: 0,
          background: "rgba(13, 27, 42, 0.98)",
        }}
        width={240}
      >
        {menuContent}
      </Drawer>
    );
  }

  // ✅ Desktop Sidebar
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={!isMobile ? collapsed : false}
      collapsedWidth={isMobile ? 0 : 80}
      width={240}
      breakpoint="lg"
      onCollapse={(value) => {
        if (!isMobile && setCollapsed) {
          setCollapsed(value);
        }
      }}
      style={{
        background: "rgba(13, 27, 42, 0.95)",
        height: "100vh",
        position: "fixed",
        top: 70,
        left: 0,
        zIndex: 1000,
      }}
    >
      {menuContent}
    </Sider>
  );
};

export default Sidebar;